import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      filter: 'brightness(90%)',
    },
  },
}));

const CloseButton = ({ row, selectedJobToClose }) => {
  const classes = useStyles();

  return (
    <Button className={classes.root} onClick={() => selectedJobToClose(row)}>
      Close
    </Button>
  );
};

CloseButton.propTypes = {
  row: PropTypes.object.isRequired,
  selectedJobToClose: PropTypes.func.isRequired,
};

export default CloseButton;
